import { FC } from 'react';

import useAddProposalGrant from '@/api/mutations/proposals/useAddProposalGrant';
import { proposalMutationScopeId } from '@/api/mutations/proposals/proposalMutationScope';
import useRemoveProposalGrant from '@/api/mutations/proposals/useRemoveProposalGrant';
import { useGetProposalFinancials } from '@/api/queries/proposal/useGetProposal';
import GrantsPicker from '@/ui/components/estimatesAndProposals/grantOption/GrantsPicker';

type GrantsTabProps = {
  proposalId: string;
  projectId: string;
};

const GrantsTab: FC<GrantsTabProps> = (props) => {
  const { proposalId, projectId } = props;

  const { grants, effectivePaymentSchedule } =
    useGetProposalFinancials(proposalId);

  const mutationArgs = {
    proposalId,
    projectId,
    options: { scope: { id: proposalMutationScopeId(proposalId) } },
  };
  const addProposalGrant = useAddProposalGrant(mutationArgs);
  const removeProposalGrant = useRemoveProposalGrant(mutationArgs);

  return (
    <GrantsPicker
      attached={grants ?? []}
      mutationScopeId={proposalMutationScopeId(proposalId)}
      onAdd={({ catalogueGrantId, grantLineId }) =>
        addProposalGrant.mutate({
          proposalId,
          sourceGrantId: catalogueGrantId,
          grantLine: { id: grantLineId },
        })
      }
      onRemove={(grantLineId) =>
        removeProposalGrant.mutate({ proposalId, grantLineId })
      }
      helperText={
        // A grant becomes a schedule stage only where a payment plan
        // already exists — one never synthesises a plan of its own.
        effectivePaymentSchedule &&
        "Each grant applied here is also added as its own stage at the end of the customer's payment schedule."
      }
    />
  );
};

export default GrantsTab;
